import React from "react";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { DateDisplay } from "../DateDisplay";
import { useHistory } from "react-router-dom";
import { InvoiceDateResponse } from "../../models/Invoice";
import { toTwilioInvoiceDetailsPage } from "../../router/navigation";
import { Typography } from "@material-ui/core";
import moment from "moment";

interface InvoiceHistoryDisplayCardProps {
	//The invoice history date object to be displayed in the card.
	invoiceHistory: InvoiceDateResponse;
	//The id for the product of the invoice.
	productId: string;
}

const useStyles = makeStyles((theme) => ({
	card: {
		borderRadius: theme.spacing(0.5),
		width: theme.breakpoints.values.md - 30,
	},
	content: {
		fontSize: 11,
		fontWeight: 700,
		letterSpacing: ".15em",
		justifyContent: "space-between",
		display: "flex",
	},
	button: {
		marginLeft: theme.spacing(2),
	},
	cardContent: {
		padding: theme.spacing(1),
	},
}));

/**
 * This component is used to display a invoice history date object which
 * allows us to then go to the invoice details page.
 * @param props
 */
export const InvoiceHistoryDisplayCard = (props: InvoiceHistoryDisplayCardProps) => {
	const classes = useStyles();
	const history = useHistory();
	const invoiceDate = moment(props.invoiceHistory.invoiceDate);

	return (
		<Card className={classes.card} data-testid="invoice-history-display-card">
			<div className={classes.cardContent}>
				<div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
					<span style={{ justifyContent: "space-between" }} data-testid="card-title">
						<Typography variant="h6" data-testid={"invoice-date-display"}>
							Invoice Date: {invoiceDate.month() + 1}/{invoiceDate.date()}/{invoiceDate.year()}
						</Typography>
					</span>
					<div
						style={{
							marginLeft: 6,
							float: "right",
							fontSize: 12,
							paddingTop: 4,
							justifyContent: "flex-end",
							paddingLeft: 6,
							paddingBottom: 10,
						}}
						data-testid={"invoice-uploaded-date-display"}
					>
						Uploaded Date: <DateDisplay date={props.invoiceHistory.dateUploaded} fontSize={12} />
					</div>
				</div>
				<div>
					<div className={classes.content}>
						<div className={classes.cardContent} data-testid={"invoice-file-count"}>
							<Typography>File Set Count: {props.invoiceHistory.fileSetCount}</Typography>
						</div>
						{props.invoiceHistory.dateSentToAccounting && (
							<div className={classes.cardContent} data-testid={"invoice-sent-to-accounting-date-display"}>
								<Typography>
									Sent to Accounting on:{" "}
									<DateDisplay date={props.invoiceHistory.dateSentToAccounting || ""} fontSize={16} />
								</Typography>
							</div>
						)}
						<Button
							size="small"
							variant="outlined"
							color={"primary"}
							onClick={() => {
								history.push(toTwilioInvoiceDetailsPage(props.productId, props.invoiceHistory.invoiceDate));
							}}
							className={classes.button}
							data-testid="view-invoice-details-button"
						>
							{"View Details"}
						</Button>
					</div>
				</div>
			</div>
		</Card>
	);
};
